export { default } from './Right';
